/* MARSTÈLA Gift Card Quick Add — solo Gift Card, tema bozza */
(function () {
  if (window.__marstelaGiftCardQuickAddReady) return;
  window.__marstelaGiftCardQuickAddReady = true;
  function dialogOf(node) {
    return node && node.closest('.marstela-gc-quickadd')?.querySelector('[data-mgcq-dialog]');
  }
  document.addEventListener('click', function (event) {
    const open = event.target.closest('[data-mgcq-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      const dlg = dialogOf(open);
      if (dlg && !dlg.open) dlg.showModal();
      return;
    }
    const close = event.target.closest('[data-mgcq-close]');
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      const dlg = close.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    const dlg = event.target.closest('dialog[data-mgcq-dialog]');
    if (dlg && event.target === dlg) dlg.close();
  }, true);
  document.addEventListener('change', function (event) {
    const radio = event.target.closest('[data-mgcq-denomination]');
    if (radio) {
      const dlg = radio.closest('dialog[data-mgcq-dialog]');
      if (!dlg || !radio.checked) return;
      const variant = dlg.querySelector('[data-mgcq-variant]');
      const price = dlg.querySelector('[data-mgcq-price]');
      if (variant) variant.value = radio.value;
      if (price) price.textContent = radio.dataset.price || '';
    }
    const gift = event.target.closest('[data-mgcq-gift]');
    if (gift) {
      const dlg = gift.closest('dialog[data-mgcq-dialog]');
      const fields = dlg && dlg.querySelector('[data-mgcq-gift-fields]');
      if (!fields) return;
      fields.hidden = !gift.checked;
      fields.querySelectorAll('input,textarea').forEach(function (field) {
        field.disabled = !gift.checked;
        if (field.matches('[data-mgcq-recipient-email]')) field.required = gift.checked;
        if (field.matches('[data-mgcq-offset]')) {
          field.value = gift.checked ? String(new Date().getTimezoneOffset()) : '';
        }
      });
    }
  });
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form[data-mgcq-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    if (!form.reportValidity()) return;
    const button = form.querySelector('[data-mgcq-submit]');
    const feedback = form.querySelector('[data-mgcq-feedback]');
    if (!button || button.disabled) return;
    feedback.textContent = '';
    const initial = button.textContent;
    button.disabled = true;
    button.textContent = 'AGGIUNTA IN CORSO…';
    try {
      const data = new FormData(form);
      for (const name of Array.from(data.keys())) {
        if (name.startsWith('mgcq-denomination-')) data.delete(name);
      }
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!response.ok) {
        const error = await response.json().catch(function () { return {}; });
        throw new Error(error.description || error.message || 'Impossibile aggiungere la Gift Card al carrello.');
      }
      window.location.assign(root + 'cart');
    } catch (error) {
      feedback.textContent = error.message || 'Errore temporaneo. Riprova.';
      button.disabled = false;
      button.textContent = initial;
    }
  }, true);
})();